import { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import { ODataBaseResponse, ODataMultipleResponse } from "@/models/responses/odata.response.interface";
import { AttestationAnnotation } from "@/models/requests/attestation.interface";
import { ValidateIne } from "@/models/responses/validateine.response";
import {
  OpportunityKitResponse,
  OpportunityResponse,
  OpportunityDataResponse,
  OfferAvailableResponse,
  MotorMessageErrorResponse,
  MotorOfferDataResponse,
  OpportunityTypeRespose,
  LeadProfilingResponse,
  LeadProfilingSpouseResponse,
  OppoPLDMatchResponse,
  LogServiciosResponse,
  JsonUpdateData,
  ConsultaSC,
  LogServIMSSResponse
} from "@/models/responses/opportunity.interface";
import { ApiService } from "./api.service";
import { FLOW_KIT_PDF_URL, FLOW_VAL_FACE_URL, FLOW_VAL_ID_FRONT_URL, SUSCRIPTION_KEY } from "@/constants/config";
import dayjs from "dayjs";
import { LeadPrincipalImssRequest } from "@/models/requests/imss.interface";
import {
  LeadOfferBeneficiaryResponse,
  LeadOfferJobResponse,
  LeadOfferLibertadRelationResponse,
  LeadOfferReferenceResponse,
  LeadOfferResponse,
  LeadResponse,
  LeadUserResponse,
  MotorResultResponse,
  LeadSearchResponse,
  IsOfferPreautorizadoResponse,
  PhoneVerification
} from "@/models/responses/lead.interface";
import { LeadBeneficiaryRequest, LeadGeneralRequest, LeadJobRequest, LeadSpouseRequest, ModalInfoPersonal, LeadLivingPlaceRequest, LeadReferenceRequest } from "@/models/requests/lead.interface";
import { Appointment } from "@/models/requests/appointment.interface";
import { DocumentKindResponse, RecordResponse } from "@/models/responses/documentation.interface";
import { variablesService } from "./variables.service";

interface OportunidadODataResponse extends ODataBaseResponse {
  _parentcontactid_value: any;
  rs_detonasolicitud?: number;
  rs_curprenapo?: string;
  rs_rfc?: string;
  _rs_lugarnacimientoid_value?: string;
  rs_genero?: number;
  _rs_paisnacimiento_value?: string;
  rs_montoseguro?: number;
  _rs_sujetocreditoid_value?: string;
  _rs_tipotramiteid_value?: string;
  opportunityid: string;
  rs_folio: string;
  rs_nombres: string;
  rs_segundonombre?: string;
  rs_apellidopaterno: string;
  rs_apellidomaterno?: string;
  statecode: number;
  rs_ocr: string;
  rs_cic: string;
  rs_anioregistro: string;
  rs_anioemision: string;
  rs_claveelector: string;
  rs_curp: string;
  rs_tipoproyecto?: number;
  rs_etapaspb?: number;
  rs_tipocliente?: number;
  rs_periodopago?: number;
  rs_afiliacionclublibertad?: boolean;
  rs_numerocredito?: string;
  rs_correoelectronico?: string;
  rs_telfonocelular?: string;
  _rs_finalidad_value?: string;
  _rs_tipoconvenioid_value?: string;
  rs_coincidenciapld?: number;
  rs_destinorecursos?: number;
  rs_fechanacimiento?: string;
  rs_edad?: number;
  rs_validarmediocontacto?: number;
  rs_origen?: number;
  rs_sucursalid?: string;
  _rs_sucursalid_value?: string;
  rs_matricula?: string;
  _rs_estadodelegacionid_value?: string;
  rs_nipautorizacion?: string;
  rs_instrumentomonetariomanejaracuentas?: number;
  rs_documentoscargados?: boolean;
  statuscode: number;
  rs_validacioncurp?: number;
  rs_nipenviado?: string;
  rs_manifiestoempleo?: boolean;
}

interface OpportunityODataResponse {
  rs_tipoproyecto: number;
}

interface DesitionalMotorErrorODataResponse {
  rs_motordecisionalid: {
    rs_resultadomotor: number;
    rs_motordecisionalid: string;
    _rs_mensajeerrorburoid_value: string;
    rs_mensajeerrorburoid: {
      rs_name: string;
    };
  };
}

interface MotorOfferODataResponse {
  rs_ofertaelegida: boolean;
  rs_ofertagenerada: boolean;
  rs_motordecisionalid: {
    rs_motordecisionalid: string;
    rs_montosolicitado: number;
    rs_mopactual: number;
    rs_mophistorico: number;
    statuscode: number;
  };
}

interface OpportunityHeadODataResponse extends ODataBaseResponse {
  opportunityid: string;
  rs_folio: string;
  rs_coincidenciapld?: number;
  rs_origen?: number;
  _rs_sucursalid_value?: string;
}

interface OppProfilingODataResponse extends ODataBaseResponse {
  rs_periodicidadingresos: any;
  rs_curprenapo: any;
  rs_montoseguro?: number;
  rs_correoelectronico: string;
  rs_telfonocelular: string;
  rs_instrumentomonetariomanejaracuentas: number;
  opportunityid: string;
  rs_folio: string;
  rs_nombres: string;
  rs_apellidopaterno: string;
  rs_apellidomaterno: string;
  rs_fechanacimiento: string;
  rs_genero: number;
  _rs_paisnacimiento_value: string;
  _rs_lugarnacimientoid_value: string;
  rs_nacionalidad: number;
  rs_telefonofijo: string;
  _rs_nivelestudios_value: string;
  rs_curp: string;
  rs_rfc: string;
  rs_nipenviado: string;
  rs_edad: number;
  rs_calle: string;
  rs_numeroexterior: string;
  rs_numerointerior: string;
  rs_codigopostal: string;
  _rs_coloniaid_value: string;
  _rs_municipioid_value: string;
  _rs_estadoid_value: string;
  rs_antiguedadciudad: string;
  rs_antiguedadvivienda: string;
  _rs_tipoviviendaid_value: string;
  rs_montorenta: number;
  _rs_sucursalid_value: string;
  rs_horariodecontacto: number;
  rs_estadocivil: number;
  rs_dependienteseconomicos: number;
  _rs_conyuge_value: string;
  _rs_profesionid_value: string;
  _rs_ocupacionid_value: string;
  rs_nombreempresa: string;
  rs_nss: string;
  rs_antiguedadempresa: string;
  rs_ingresosfijos: number;
  rs_ingresosvariables: number;
  rs_tipoclienteimss: number;
  _rs_tipoproductoimssid_value: string;
  _rs_tipoconvenioid_value: string;
  rs_montorequerido: number;
  rs_montototalapagar: number;
  rs_montototalinteres: number;
  rs_montototaliva: number;
  rs_descuentomensual: number;
  rs_capacidadpago: number;
  rs_fechavencimiento: string;
  rs_fechaprimerdescuento: string;
  rs_cuentacapacidadpago: number;
  rs_pagofijo: number;
  rs_plazos: number;
  rs_catsiniva: number;
  _rs_bancoid_value: string;
  rs_cuentaclave: string;
  rs_plazoquincenal: number;
  rs_montomaximo: number;
  rs_tasa: number;
  rs_periodopago: number;
  //
  rs_nombrepatron: string;
  rs_continuarmismoingreso: number;
  rs_salariobasecotizacion: number;
  rs_estadoempleado: number;
  rs_fechaingreso: string;
  rs_fechabaja: string;
  _rs_actividadbanxicoid_value: string;
  _rs_actividadeconomicaid_value: string;
  _rs_puestoid_value: string;
  _rs_sectoreconomicoid_value: string;
  rs_tipocliente: number;
  _rs_sujetocreditoid_value: string;
  _rs_tipotramiteid_value: number;
  rs_segundonombre: string;
}

interface LeadProfilingConyugeODataResponse extends ODataBaseResponse {
  rs_nombre: string;
  rs_segundonombre?: string;
  rs_apellidopaterno: string;
  rs_apellidomaterno?: string;
  rs_fechanacimiento: string;
  rs_genero: number;
  rs_nipenviado: string;
  rs_nacionalidad: number;
  _rs_lugarnacimientoid_value: string;
  rs_curp?: string;
  rs_rfc?: string;
  _rs_ocupacionid_value: string;
  _rs_regimenmatrimonial_value: string;
}

interface LeadUserODataResponse extends ODataBaseResponse {
  rs_sucursalid: {
    _rs_gerentesucursalid_value: string;
    rs_sucursalid: string;
  };
  rs_telfonocelular: string;
  rs_folio: string;
}

interface AppointmentODataResponse extends ODataBaseResponse {
  appointmentid: string;
}

interface DesitionalMotorODataResponse {
  rs_motordecisionalid: {
    rs_mensajemotor: string;
    rs_resultadomotor: number;
    rs_ofertaminima: boolean;
    rs_motordecisionalid: string;
  };
}

interface FileDataResponse {
  rs_expedienteid: string;
  rs_name: string;
  _rs_grupodocumentoid_value: string;
  _rs_tipodocumentoid_value: string;
}

interface AgreementTypeDataResponse {
  _rs_tipoconvenioid_value: string;
}

interface LeadOfferReferenciaODataResponse extends ODataBaseResponse {
  rs_nombre: string;
  rs_segundonombre?: string;
  rs_apellidopaterno: string;
  rs_apellidomaterno?: string;
  rs_parentesco: number;
  rs_telefonocelular: string;
  rs_telefonocasa?: string;
  rs_tiemporelacion: string;
}

interface LeadOfferBeneficiarioODataResponse extends ODataBaseResponse {
  rs_nombre: string;
  rs_segundonombre?: string;
  rs_apellidopaterno: string;
  rs_apellidomaterno?: string;
  rs_parentesco: number;
  rs_fechanacimiento: string;
  _rs_lugarnacimientoid_value: string;
  rs_telefono: string;
  rs_porcentajebeneficio: number;
  rs_codigopostal: string;
  rs_calle: string;
  rs_numeroexterior: string;
  rs_numerointerior: string;
  _rs_coloniaid_value: string;
  _rs_municipioid_value: string;
  rs_rfc: string;
  rs_tipobeneficiario: number;
  rs_beneficiarioid: string;
}

interface LeadOfferEmpleoODataResponse extends ODataBaseResponse {
  _rs_puestoid_value: string;
  rs_name: string;
  _rs_actividadeconomicaid_value: string;
  _rs_sectoreconomicoid_value: string;
  rs_periodicidadingresos: number;
  rs_telefono: string;
  rs_extension?: string;
  rs_codigopostal: string;
  rs_calle: string;
  rs_numeroexterior: string;
  rs_numerointerior: string;
  _rs_coloniaid_value: string;
  _rs_municipioid_value: string;
  _rs_entidadfederativaid_value: string;
  rs_empleoid: string;
}

interface LeadOfferDataResponse {
  _rs_empleoid_value: string | undefined;
  rs_parentescocliente: boolean;
  rs_parentesco1: number;
  rs_nombre1: string;
  rs_parentescoconsejo: boolean;
  rs_parentesco2: number;
  rs_nombre2: string;
  rs_formaparteconsejo: boolean;
  rs_cargo1: string;
  rs_poseeacciones: boolean;
  rs_eepecificarporcentaje: number;
  rs_accionespersonamoral: boolean;
  rs_denominacionsocial1: string;
  rs_consejoclienteprospecto: boolean;
  rs_denominacionsocial2: string;
  rs_nombreintegranteconsejo: string;
  rs_cargo2: string;
  rs_numclientereferido: string;
  rs_regimenpfopfae: boolean;
  rs_clienteactuacuentapropia: boolean;
  rs_dedondeprovienenlosrecursos_list: number;
  rs_procedenciarecursoscuenta_list: number;
  rs_importeesperamanejarmes_list: number;
  rs_montodepositos_list: number;
  rs_montoretiros_list: number;
  rs_numerodepositos_list: number;
  rs_numeroretiros_list: number;
  rs_aceptapublicidad: boolean;
  decisionmaker: boolean;
  rs_destinorecursoscuenta: number;
  rs_instrumentomonetariomanejacuenta: number;
}

interface ConyugeODataResponse extends ODataBaseResponse {
  rs_conyugeid: string;
}

interface OppHeadODataResponse extends ODataBaseResponse {
  opportunityid: string;
  rs_folio: string;
  _rs_finalidad_value?: string;
  statecode: number;
  rs_tipocliente: number;
  rs_tipoproyecto: number;
}

interface TipoDocumentoODataResponse {
  rs_name: string;
  rs_expedienteid: string;
  rs_tipodocumentoid: {
    rs_id: string;
    rs_name: string;
  };
}

interface ExpedienteODataResponse {
  rs_name: string;
  rs_expedienteid: string;
  rs_tipodocumentoid: {
    rs_id: string;
    rs_name: string;
  };
  rs_path: string;
  rs_fechavigenciacartalibranza: string;
  rs_mediatype: string;
  _rs_tipodocumentoid_value: string;
  rs_fechaemisioncartalibranza: string;
  rs_foliocartalibranza: string;
  rs_estatuscartalibranza: number;
}

interface BeneficiarioODataResponse extends ODataBaseResponse {
  rs_beneficiarioid: string;
}

interface IsOfferPreautorizadoOData {
  rs_productoid?: {
    rs_aplicapreautorizado?: boolean;
  };
}

interface IdDocsODataResponse {
  rs_name?: string;
  rs_tipodocumentoid?: {
    rs_id?: string;
  };
}

interface LogServiciosODataResponse {
  rs_response?: string;
  rs_stateendpoint?: number;
}

interface PhoneVerificationODataResponse {
  rs_intentosvalidacionnumcel: number;
  statuscode: number;
}

interface ConsultaSCODataResponse {
  createdon: string;
  rs_estatusempleo: string;
  rs_tiposerviciopalenca?: number;
}

interface JsonUpdateDataODataResponse {
  rs_jsondatosactualizado: string;
}

interface LogServIMSSODataResponse {
  rs_tiempoconsultaimss: string;
  rs_logserviciosid: string;
}

interface LogEmployedODataResponse {
  rs_response: string;
}

interface LogPLD {
  rs_response: string;
  rs_logserviciosid: string;
  /* rs_prospectoid: {
    leadid: string
  } */
  rs_confirmamensajepld: number;
  rs_stateendpoint: number;
}

interface ReferenciaODataResponse extends ODataBaseResponse {
  rs_referenciaid: string;
}

class OpportunityService extends ApiService {
  public constructor(config?: AxiosRequestConfig) {
    super(config);

    this.find = this.find.bind(this);
    this.findConfirmation = this.findConfirmation.bind(this);
    this.sendSms = this.sendSms.bind(this);
    this.triggerDocumentCreation = this.triggerDocumentCreation.bind(this);
    this.triggerDocumentUpdate = this.triggerDocumentUpdate.bind(this);
    this.triggerOpportunityClose = this.triggerOpportunityClose.bind(this);
    this.createAnnotation = this.createAnnotation.bind(this);
    this.requestDocumentationKit = this.requestDocumentationKit.bind(this);
    this.validateProofIdFront = this.validateProofIdFront.bind(this);
    this.checkSelfieValidationLocked = this.checkSelfieValidationLocked.bind(this);
    this.validateSelfie = this.validateSelfie.bind(this);
    this.updateStepOpportunityClose = this.updateStepOpportunityClose.bind(this);
    this.releaseTypeOpportunity = this.releaseTypeOpportunity.bind(this);
  }

  /**
   * Find the Opportunity by its Id
   *
   * @param {string} id
   * @returns {Promise<OpportunityResponse | undefined>}
   * @memberof OpportunityService
   */
  public async find(id: string): Promise<OpportunityResponse | undefined> {
    const res = await this.get<OpportunityResponse, AxiosResponse<OportunidadODataResponse>>(
      `d365api/v1/opportunities(${id})?$select=opportunityid,rs_folio,rs_nombres,rs_segundonombre,rs_apellidopaterno` +
        ",rs_apellidomaterno,statecode,rs_ocr,rs_cic,rs_anioregistro,rs_anioemision,rs_claveelector,rs_curp,rs_tipoproyecto" +
        ",rs_etapaspb,rs_tipocliente,rs_periodopago,rs_numerocredito,rs_correoelectronico,rs_telfonocelular" +
        ",_rs_finalidad_value,_rs_tipoconvenioid_value,rs_coincidenciapld,rs_destinorecursos,rs_fechanacimiento,rs_edad" +
        ",rs_validarmediocontacto,rs_origen,_rs_sucursalid_value,rs_matricula,_rs_estadodelegacionid_value,rs_nipautorizacion" +
        ",_rs_sujetocreditoid_value,_rs_tipotramiteid_value,rs_instrumentomonetariomanejaracuentas,rs_documentoscargados,rs_montoseguro" +
        ",_rs_paisnacimiento_value,rs_genero,_rs_lugarnacimientoid_value,rs_rfc,statuscode,rs_curprenapo,rs_detonasolicitud" +
        ",_parentcontactid_value",
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    if (res.data.statecode !== 0) {
      return undefined;
    }
    let names = res.data.rs_nombres;
    const ap = res.data.rs_apellidopaterno;
    const am = res.data.rs_apellidomaterno as string;
    let fullname = res.data.rs_nombres;
    if (res.data.rs_segundonombre) {
      fullname += ` ${res.data.rs_segundonombre}`;
      names += ` ${res.data.rs_segundonombre}`;
    }
    fullname += ` ${res.data.rs_apellidopaterno}`;
    if (res.data.rs_apellidomaterno) {
      fullname += ` ${res.data.rs_apellidomaterno}`;
    }

    return {
      id: res.data.opportunityid,
      number: res.data.rs_folio,
      fullname: fullname,
      firstName: res.data.rs_nombres,
      lastName: ap,
      middleName: am,
      secondName: res.data.rs_segundonombre,
      ocr: res.data.rs_ocr,
      year1: res.data.rs_anioregistro,
      year2: res.data.rs_anioemision,
      issueNumber: "00",
      electorKey: res.data.rs_claveelector,
      cic: res.data.rs_cic,
      curp: res.data.rs_curp,
      projectType: res.data.rs_tipoproyecto,
      stepPB: res.data.rs_etapaspb,
      clientType: res.data.rs_tipocliente,
      statecode: res.data.statecode,
      paymentPeriod: res.data.rs_periodopago,
      numCredito: res.data.rs_numerocredito,
      email: res.data.rs_correoelectronico,
      phone: res.data.rs_telfonocelular,
      purposeId: res.data._rs_finalidad_value,
      agreementTypeId: res.data._rs_tipoconvenioid_value,
      pldMatch: res.data.rs_coincidenciapld,
      purposeResources: res.data.rs_destinorecursos,
      birthDate: res.data.rs_fechanacimiento,
      age: res.data.rs_edad,
      contactMean: res.data.rs_validarmediocontacto,
      origen: res.data.rs_origen,
      branchId: res.data._rs_sucursalid_value,
      enrollment: res.data.rs_matricula,
      delegationState: res.data._rs_estadodelegacionid_value == null ? res.data._rs_lugarnacimientoid_value : res.data._rs_estadodelegacionid_value,
      nip: res.data.rs_nipautorizacion,
      subjectCredit: res.data._rs_sujetocreditoid_value,
      procedureType: res.data._rs_tipotramiteid_value,
      monetaryInstrument: res.data.rs_instrumentomonetariomanejaracuentas,
      chargeDocs: res.data.rs_documentoscargados,
      debtInsurance: res.data.rs_montoseguro,
      country: res.data._rs_paisnacimiento_value,
      gender: res.data.rs_genero,
      rfc: res.data.rs_rfc,
      statuscode: res.data.statuscode,
      curprenapo: res.data.rs_curprenapo,
      triggersRequest: res.data.rs_detonasolicitud,
      contactId: res.data._parentcontactid_value
    };
  }

  /**
   * Find the Opportunity by its Id
   *
   * @param {string} id
   * @returns {Promise<OpportunityResponse | undefined>}
   * @memberof OpportunityService
   */
  public async findDebt(id: string): Promise<OpportunityResponse | undefined> {
    //
    const res = await this.get<OpportunityResponse, AxiosResponse<OportunidadODataResponse>>(
      `d365api/v1/opportunities(${id})?$select=opportunityid,rs_folio,rs_nombres,rs_segundonombre,rs_apellidopaterno,rs_apellidomaterno,statecode,rs_ocr,rs_cic,rs_anioregistro,rs_anioemision,rs_claveelector,rs_curp,rs_tipoproyecto,rs_etapaspb`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    let names = res.data.rs_nombres;
    const ap = res.data.rs_apellidopaterno;
    const am = res.data.rs_apellidomaterno as string;
    let fullname = res.data.rs_nombres;
    if (res.data.rs_segundonombre) {
      fullname += ` ${res.data.rs_segundonombre}`;
      names += ` ${res.data.rs_segundonombre}`;
    }
    fullname += ` ${res.data.rs_apellidopaterno}`;
    if (res.data.rs_apellidomaterno) {
      fullname += ` ${res.data.rs_apellidomaterno}`;
    }

    return {
      id: res.data.opportunityid,
      number: res.data.rs_folio,
      fullname: fullname,
      firstName: res.data.rs_nombres,
      lastName: ap,
      middleName: am,
      secondName: res.data.rs_segundonombre,
      ocr: res.data.rs_ocr,
      year1: res.data.rs_anioregistro,
      year2: res.data.rs_anioemision,
      issueNumber: "00",
      electorKey: res.data.rs_claveelector,
      cic: res.data.rs_cic,
      curp: res.data.rs_curp,
      projectType: res.data.rs_tipoproyecto,
      stepPB: res.data.rs_etapaspb
    };
  }

  /**
   * Find if the Opportunity matches the RFC and the Confirmation Code (NIP)
   *
   * @param {string} id
   * @param {string} rfc
   * @param {string} nip
   * @returns {Promise<boolean>}
   * @memberof OpportunityService
   */
  public async findConfirmation(id: string, rfc: string, nip: string): Promise<boolean> {
    // FIXME: Should not send request 'as is' since it can be modified and nip verification excluded, it should also be a POST method
    const res = await this.get<{ opportunityid: string; rs_folio: string }, AxiosResponse<ODataMultipleResponse<{ opportunityid: string; rs_folio: string }[]>>>(
      `d365api/v1/opportunities?$select=opportunityid,rs_folio&$filter=rs_rfc eq '${rfc}' and rs_codigoverificadorenviado eq '${nip}' and opportunityid eq ('${id}')`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
    return res.data.value.length == 1 && res.data.value[0].opportunityid !== undefined && res.data.value[0].rs_folio !== undefined;
  }

  public async findVerification(id: string, nip: string): Promise<boolean> {
    const res = await this.get<{ opportunityid: string }, AxiosResponse<ODataMultipleResponse<{ opportunityid: string; rs_folio: string }[]>>>(
      `d365api/v1/opportunities?$select=opportunityid&$filter=rs_codigoverificadorenviado eq '${nip}' and opportunityid eq ('${id}')`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
    return res.data?.value.length == 1 && res.data?.value[0].opportunityid !== undefined && res.data?.value[0].opportunityid !== null;
  }

  /**
   * Sends an SMS to the specified Opportunity ID.
   *
   * @param {string} id
   * @returns {(Promise<string | undefined>)}
   * @memberof OpportunityService
   */
  public async sendSms(id: string): Promise<void> {
    // FIXME: This shouldn't be done like this but as I mentioned several times, there's no backend for the frontend ¯\(°_o)/¯
    const res = await this.get<{ rs_telfonocelular: string; rs_codigoverificadorenviado: string }, AxiosResponse<{ rs_telfonocelular: string; rs_codigoverificadorenviado: string }>>(
      `d365api/v1/opportunities(${id})?$select=opportunityid,rs_telfonocelular,rs_codigoverificadorenviado`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    await this.post<unknown, unknown, AxiosResponse<unknown>>(
      "v1",
      {
        message: `Tu NIP de verificación es: ${res.data.rs_codigoverificadorenviado}`,
        msisdns: [`52${res.data.rs_telfonocelular}`],
        tag: "verifica-portal"
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
  }

  /**
   * Triggers the Document Creation
   *
   * @param {string} id
   * @returns {Promise<unknown>}
   * @memberof OpportunityService
   */
  public async triggerDocumentCreation(id: string): Promise<unknown> {
    return this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/opportunities(${id})`,
      {
        rs_detonaplanpagos: true
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    )
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        throw error;
      });
  }

  /**
   * Triggers the Document Update
   *
   * @param {string} id
   * @param {authorizeInstructions: boolean; authorizeSeguroDeuda: boolean; authorizeAds: boolean; authorizeTokenService: boolean} survey
   * @returns {Promise<unknown>}
   * @memberof OpportunityService
   */
  public async triggerDocumentUpdate(id: string, survey: { authorizeInstructions: boolean; authorizeSeguroDeuda: boolean; authorizeAds: boolean; authorizeTokenService: boolean }): Promise<unknown> {
    return this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/opportunities(${id})`,
      {
        rs_detonakitliberacion: true,
        rs_instruccionescargolibercuenta: survey.authorizeInstructions ? "2" : "1",
        rs_autorizacobrosegurodeuda: survey.authorizeSeguroDeuda ? "2" : "1",
        rs_envioinformacionpromocional: survey.authorizeAds ? "2" : "1",
        rs_contrataserviciotokenfisico: survey.authorizeTokenService ? "2" : "1"
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    )
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        throw error;
      });
  }

  /**
   * Triggers the Opportunity Close
   *
   * @param {string} id
   * @returns {Promise<unknown>}
   * @memberof OpportunityService
   */
  public async triggerOpportunityClose(id: string): Promise<unknown> {
    return this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/opportunities(${id})`,
      {
        rs_detonaliberacioncredito: true
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    )
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        throw error;
      });
  }

  public async releaseTypeOpportunity(id: string): Promise<unknown> {
    return this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/opportunities(${id})`,
      {
        rs_tipoliberacion: 2
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    )
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        throw error;
      });
  }

  /**
   * Creates an Annotation and links it to the Opportunity
   *
   * @param {string} id
   * @param {Readonly<AttestationAnnotation>} annotation
   * @returns {Promise<string>}
   * @memberof OpportunityService
   */
  public async createAnnotation(id: string, annotation: Readonly<AttestationAnnotation>): Promise<string> {
    const res = await this.post<{ annotationid: string }, unknown, AxiosResponse<{ annotationid: string }>>(
      "d365api/v1/annotations?$select=annotationid",
      {
        "objectid_opportunity@odata.bind": `/opportunities(${id})`,
        subject: annotation.subject,
        notetext: annotation.description,
        filename: `EXPEDIENTE_${annotation.filename}`,
        isdocument: true,
        documentbody: annotation.base64
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
    return res.data.annotationid;
  }

  /**
   * Requests the Documentation's Kit for the specified Opportunity
   *
   * @param {string} id
   * @returns {Promise<OpportunityKitResponse[]>}
   * @memberof OpportunityService
   */
  public async requestDocumentationKit(id: string): Promise<OpportunityKitResponse[]> {
    const res = await this.post<{ nombre_documento: string; descripcion: string; base64: string }, unknown, AxiosResponse<{ nombre_documento: string; descripcion: string; base64: string }[]>>(
      `Flows/v1/workflows/${FLOW_KIT_PDF_URL}/triggers/manual/paths/invoke`,
      {
        GUID: id
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    const kit: OpportunityKitResponse[] = [];
    res.data.forEach((r) =>
      kit.push({
        filename: r.nombre_documento,
        description: r.descripcion,
        base64: r.base64
      })
    );
    return kit;
  }

  /**
   * Returns a value indicating if the Proof of ID (front) document is valid.
   *
   * @param {string} id
   * @param {string} content
   * @returns {Promise<ValidateIne>}
   * @memberof OpportunityService
   */
  public async validateProofIdFront(id: Readonly<string>, content: Readonly<string>): Promise<ValidateIne> {
    const res = await this.post<ValidateIne, unknown, AxiosResponse<ValidateIne>>(
      `Flows/v1/workflows/${FLOW_VAL_ID_FRONT_URL}/triggers/manual/paths/invoke`,
      {
        GUID: id,
        base64: content
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
    return {
      validation: res.data.validation,
      Message1: res.data.Message1,
      Message2: res.data.Message2
    };
  }

  /**
   * Returns a value indicating if the Selfie validation is locked.
   *
   * @param {string} id
   * @param {string} content
   * @returns {Promise<boolean>}
   * @memberof OpportunityService
   */
  public async checkSelfieValidationLocked(id: Readonly<string>): Promise<boolean> {
    const res = await this.get<{ opportunityid: string; rs_intentosbiometrico: number }, AxiosResponse<{ opportunityid: string; rs_intentosbiometrico: number }>>(
      `d365api/v1/opportunities(${id})?$select=opportunityid,rs_intentosbiometrico`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    return res.data.rs_intentosbiometrico < 3;
  }

  /**
   * Returns a value indicating if the Selfie is valid.
   *
   * @param {string} id
   * @param {string} content
   * @returns {Promise<boolean>}
   * @memberof OpportunityService
   */
  public async validateSelfie(id: Readonly<string>, content: Readonly<string>): Promise<boolean> {
    const res = await this.post<{ validation: boolean }, unknown, AxiosResponse<{ validation: boolean }>>(
      `Flows/v1/workflows/${FLOW_VAL_FACE_URL}/triggers/manual/paths/invoke`,
      {
        GUID: id,
        Base64: content
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    return res.data.validation;
  }

  // 1.5 kg bistec de res al corte
  // 3 pzas porterhouse de 2 pulgadas de grosor
  // 2 kg tortillas
  // 1 bolsita de la salsa mas picosa

  public async locationOpportunityClose(id: string): Promise<unknown> {
    return this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/opportunities(${id})`,
      {
        rs_confirmacionubicacion: 2
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    )
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        throw error;
      });
  }

  public async updateStepOpportunityClose(id: string, step: number): Promise<unknown> {
    return this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/opportunities(${id})`,
      {
        rs_etapaspb: step
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    )
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        throw error;
      });
  }

  public async getId(folio: string): Promise<string> {
    const res = await this.get<{ opportunityid: string; rs_folio: string }, AxiosResponse<ODataMultipleResponse<{ opportunityid: string }[]>>>(
      `d365api/v1/opportunities?$select=opportunityid,createdon&$filter=(rs_folio eq '${folio}')&$orderby=createdon desc`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
    return res.data.value[0].opportunityid;
  }

  public async getDesicionalMotorAuth(id: string): Promise<boolean> {
    const res = await this.get<{ rs_estatusconsultaburo?: number }, AxiosResponse<ODataMultipleResponse<{ rs_estatusconsultaburo?: number }>>>(
      `d365api/v1/rs_motordecisionals?$select=rs_estatusconsultaburo&$filter=(_rs_solicitudid_value eq ${id})`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    return res.data.value[0].rs_estatusconsultaburo == null ? false : true;
  }

  public async desicionalMotorAuthorized(id: string): Promise<unknown> {
    //recuperar el registro de motor decisiconal relacionado a la oprotunidad y actualizar el campo rs_estatusconsultaburo en Pendiente Consulta (717810000)
    const res = await this.get<{ rs_motordecisionalid?: string }, AxiosResponse<ODataMultipleResponse<{ rs_motordecisionalid?: string }>>>(
      `d365api/v1/rs_motordecisionals?$select=rs_motordecisionalid&$filter=(_rs_solicitudid_value eq ${id})`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    if (!res.data.value) return;
    return this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/rs_motordecisionals(${res.data.value[0].rs_motordecisionalid})`,
      {
        rs_estatusconsultaburo: 717810000
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    )
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        return Promise.reject(error);
      });
  }

  public async getCreditBureauRetries(id: string): Promise<number> {
    // FIXME: Should not send request 'as is' since it can be modified and nip verification excluded, it should also be a POST method
    const res = await this.get<{ rs_intentosautenticacionbc?: number; rs_fechaautenticacionbc: string }, AxiosResponse<{ rs_intentosautenticacionbc?: number; rs_fechaautenticacionbc: string }>>(
      `d365api/v1/opportunities(${id})?$select=opportunityid,rs_intentosautenticacionbc,rs_fechaautenticacionbc`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
    if (dayjs(res.data.rs_fechaautenticacionbc).isToday()) {
      return res.data.rs_intentosautenticacionbc ?? 0;
    } else {
      return 0;
    }
  }

  public async findData(id: string): Promise<OpportunityDataResponse> {
    const res = await this.get<OpportunityDataResponse, AxiosResponse<OpportunityODataResponse>>(`d365api/v1/opportunities(${id})?$select=rs_tipoproyecto`, {
      headers: {
        "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
      }
    });

    return {
      proyectType: res.data.rs_tipoproyecto
    };
  }

  public async checkOffers(id: string): Promise<OfferAvailableResponse> {
    const res = await this.get<
      { opportunityid: string; rs_ofertagenerada: boolean; rs_resultadomotor: number | null },
      AxiosResponse<{ opportunityid: string; rs_ofertagenerada: boolean; rs_resultadomotor: number | null }>
    >(`d365api/v1/opportunities(${id})?$select=opportunityid,rs_ofertagenerada,rs_resultadomotor`, {
      headers: {
        "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
      }
    });

    // rs_resultadomotor values: ACEPTADO (1), RECHAZADO (2), null
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return { available: res!.data.rs_ofertagenerada, accepted: res!.data.rs_resultadomotor };
  }

  public async getRejectMessageMotor(id: string): Promise<MotorMessageErrorResponse> {
    const response = await this.get<MotorMessageErrorResponse, AxiosResponse<DesitionalMotorErrorODataResponse>>(
      `d365api/v1/opportunities(${id})?$select=opportunityid&$expand=rs_motordecisionalid($select=rs_motordecisionalid,rs_resultadomotor,_rs_mensajeerrorburoid_value;$expand=rs_mensajeerrorburoid($select=rs_name))`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    const result: MotorMessageErrorResponse = {
      motorResult: response.data?.rs_motordecisionalid?.rs_resultadomotor,
      motorErrorMessage: response.data?.rs_motordecisionalid?.rs_mensajeerrorburoid?.rs_name,
      rs_motordecisionalid: response.data?.rs_motordecisionalid?.rs_motordecisionalid
    };

    return result;
  }

  public async validateMop99(id: string, values: string): Promise<boolean> {
    const res = await this.get<{ opportunityid: string }, AxiosResponse<ODataMultipleResponse<{ opportunityid: string }[]>>>(
      `d365api/v1/opportunities?fetchXml=%3Cfetch%3E%0D%0A%3Centity%20name%3D%22opportunity%22%3E%0D%0A%3Cattribute%20name%3D%22opportunityid%22%2F%3E%0D%0A%3Cfilter%20type%3D%22and%22%3E%0D%0A%3Ccondition%20attribute%3D%22opportunityid%22%20operator%3D%22eq%22%20value%3D%22${id}%22%2F%3E%0D%0A%3Ccondition%20entityname%3D%22rs_tl%22%20attribute%3D%22rs_mop%22%20operator%3D%22in%22${values}%3E%0D%0A%3C%2Fcondition%3E%0D%0A%3Ccondition%20entityname%3D%22rs_consultaburocredito%22%20attribute%3D%22statecode%22%20operator%3D%22eq%22%20value%3D%220%22%2F%3E%0D%0A%3Ccondition%20entityname%3D%22rs_intl%22%20attribute%3D%22statecode%22%20operator%3D%22eq%22%20value%3D%220%22%2F%3E%0D%0A%3Ccondition%20entityname%3D%22rs_tl%22%20attribute%3D%22statecode%22%20operator%3D%22eq%22%20value%3D%220%22%2F%3E%0D%0A%3C%2Ffilter%3E%0D%0A%3Clink-entity%20name%3D%22rs_consultaburocredito%22%20from%3D%22rs_consultaburoid%22%20to%3D%22opportunityid%22%20link-type%3D%22inner%22%3E%0D%0A%3Clink-entity%20name%3D%22rs_intl%22%20from%3D%22rs_consultaburoid%22%20to%3D%22rs_consultaburocreditoid%22%20link-type%3D%22inner%22%3E%0D%0A%3Clink-entity%20name%3D%22rs_tl%22%20from%3D%22rs_intlid%22%20to%3D%22rs_intlid%22%20link-type%3D%22inner%22%2F%3E%0D%0A%3C%2Flink-entity%3E%0D%0A%3C%2Flink-entity%3E%0D%0A%3C%2Fentity%3E%0D%0A%3C%2Ffetch%3E`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
    return res.data.value[0]?.opportunityid ? true : false;
  }

  public async triggerCreditRejected(id: string): Promise<unknown> {
    return this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/opportunities(${id})`,
      {
        statecode: 2,
        statuscode: 717810026
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    )
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        throw error;
      });
  }

  public async getMotorOfferData(id: string): Promise<MotorOfferDataResponse> {
    const resMotor = await this.get<MotorOfferODataResponse, AxiosResponse<MotorOfferODataResponse>>(
      `d365api/v1/opportunities(${id})?$select=opportunityid,rs_ofertagenerada,rs_ofertaelegida&$expand=rs_motordecisionalid($select=rs_montosolicitado,rs_mopactual,rs_mophistorico,statuscode,rs_motordecisionalid)`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    if (resMotor != null && resMotor.data != null && resMotor.data?.rs_motordecisionalid != null) {
      return {
        amountRequest: resMotor.data?.rs_motordecisionalid?.rs_montosolicitado,
        actualMop: resMotor.data?.rs_motordecisionalid?.rs_mopactual,
        historicalMop: resMotor.data?.rs_motordecisionalid?.rs_mophistorico,
        status: resMotor.data?.rs_motordecisionalid?.statuscode,
        rs_ofertaelegida: resMotor.data?.rs_ofertaelegida,
        rs_ofertagenerada: resMotor.data?.rs_ofertagenerada,
        rs_motordecisionalid: resMotor.data?.rs_motordecisionalid?.rs_motordecisionalid
      };
    }

    return null;
  }

  public async findType(id: string): Promise<OpportunityTypeRespose> {
    const res = await this.get<OpportunityTypeRespose, AxiosResponse<OportunidadODataResponse>>(`d365api/v1/opportunities(${id})?$select=rs_tipocliente,rs_tipoproyecto`, {
      headers: {
        "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
      }
    });

    return {
      tipoCliente: res.data.rs_tipocliente,
      proyectType: res.data.rs_tipoproyecto
    };
  }

  public async createOpportunityImss(request: LeadPrincipalImssRequest): Promise<string> {
    const res = await this.post<OpportunityHeadODataResponse, unknown, AxiosResponse<OpportunityHeadODataResponse>>(
      "d365api/v1/opportunities?$select=opportunityid",
      {
        rs_tipocliente: 1,
        rs_tipoproyecto: 0,
        "rs_tipoconvenioid@odata.bind": `/rs_tipoconvenios(${request.agreementTypeId})`,
        rs_validarmediocontacto: request.contactMean,
        rs_edad: request.age,
        rs_matricula: request.enrollment,
        "rs_estadodelegacionid@odata.bind": request.delegationState ? `/rs_entidadfederativas(${request.delegationState})` : null,
        rs_correoelectronico: request.email,
        rs_telfonocelular: request.mobile,
        "rs_sujetocreditoid@odata.bind": request.subjectCredit ? `/rs_sujetocreditos(${request.subjectCredit})` : null,
        "rs_tipotramiteid@odata.bind": request.procedureType ? `/rs_tipotramites(${request.procedureType})` : null
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
    return res.data.opportunityid;
  }

  /*--------------------------------------------------------------------------------------------------------------------------------------------*/
  public async getOppoProfiling(id: string): Promise<Partial<LeadProfilingResponse>> {
    const res = await this.get<Partial<LeadProfilingResponse>, AxiosResponse<OppProfilingODataResponse>>(
      `d365api/v1/opportunities(${id})?$select=opportunityid,rs_folio,rs_nombres,rs_apellidopaterno,rs_apellidomaterno,rs_telfonocelular,rs_correoelectronico` +
        `,rs_validarmediocontacto,rs_matricula,_rs_sujetocreditoid_value,_rs_tipotramiteid_value` +
        ",rs_fechanacimiento,rs_genero,_rs_paisnacimiento_value,_rs_lugarnacimientoid_value,rs_nacionalidad" +
        ",rs_telefonofijo,_rs_nivelestudios_value,rs_curp,rs_rfc,rs_nipenviado,rs_edad,rs_calle,rs_numeroexterior" +
        ",rs_numerointerior,rs_codigopostal,_rs_coloniaid_value,_rs_municipioid_value,_rs_estadoid_value" +
        ",rs_antiguedadciudad,rs_antiguedadvivienda,_rs_tipoviviendaid_value,rs_montorenta,_rs_sucursalid_value" +
        ",rs_horariodecontacto,rs_estadocivil,rs_dependienteseconomicos,_rs_conyuge_value" +
        ",_rs_profesionid_value,_rs_ocupacionid_value,rs_nombreempresa,rs_nss,rs_antiguedadempresa,rs_ingresosfijos" +
        ",rs_ingresosvariables,rs_tipoclienteimss,_rs_tipoproductoimssid_value,_rs_tipoconvenioid_value,rs_montorequerido" +
        ",rs_montototalapagar,rs_montototalinteres,rs_montototaliva,rs_descuentomensual,rs_capacidadpago,rs_fechavencimiento" +
        ",rs_fechaprimerdescuento,rs_cuentacapacidadpago,rs_pagofijo,rs_plazos,rs_catsiniva,_rs_bancoid_value,rs_cuentaclave" +
        ",rs_plazoquincenal,rs_montomaximo,rs_tasa,rs_periodopago,rs_segundonombre,rs_curprenapo,rs_periodicidadingresos" +
        //
        ",rs_nombrepatron,rs_continuarmismoingreso,rs_salariobasecotizacion,rs_estadoempleado,rs_fechaingreso,rs_fechabaja,rs_instrumentomonetariomanejaracuentas" +
        ",_rs_actividadbanxicoid_value,_rs_actividadeconomicaid_value,_rs_ocupacionid_value,_rs_puestoid_value,_rs_sectoreconomicoid_value,rs_tipocliente",
      //"&$expand=rs_lead_quote_prospectoid($select=name,quoteid,rs_monto,_rs_productoid_value;$expand=rs_productoid($select=rs_aplicapreautorizado))",
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    let spouse: Partial<LeadProfilingSpouseResponse> | undefined;
    if (res.data._rs_conyuge_value) {
      spouse = {};
      const rs = await this.get<Partial<LeadProfilingSpouseResponse>, AxiosResponse<LeadProfilingConyugeODataResponse>>(`d365api/v1/rs_conyuges(${res.data._rs_conyuge_value})`, {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      });
      spouse.firstName = rs.data.rs_nombre;
      spouse.middleName = rs.data.rs_segundonombre;
      spouse.lastName = rs.data.rs_apellidopaterno;
      spouse.mothersLastName = rs.data.rs_apellidomaterno;
      spouse.birthDate = rs.data.rs_fechanacimiento;
      spouse.genre = rs.data.rs_genero;
      spouse.nip = res.data.rs_nipenviado;
      spouse.birthPlaceId = rs.data._rs_lugarnacimientoid_value;
      spouse.nationality = rs.data.rs_nacionalidad;
      spouse.occupationId = rs.data._rs_ocupacionid_value;
      spouse.matrimonialRegimeId = rs.data._rs_regimenmatrimonial_value;
      spouse.curp = rs.data.rs_curp;
      spouse.rfc = rs.data.rs_rfc;
    }

    return {
      id: res.data.opportunityid,
      number: res.data.rs_folio,
      firstName: res.data.rs_nombres,
      middleName: res.data.rs_segundonombre,
      lastName: res.data.rs_apellidopaterno,
      mothersLastName: res.data.rs_apellidomaterno,
      birthDate: res.data.rs_fechanacimiento,
      phone: res.data.rs_telfonocelular,
      email: res.data.rs_correoelectronico,
      landlinePhone: res.data.rs_telefonofijo,
      genre: res.data.rs_genero,
      birthCountryId: res.data._rs_paisnacimiento_value,
      birthPlaceId: res.data._rs_lugarnacimientoid_value,
      nationality: res.data.rs_nacionalidad,
      educationLevelId: res.data._rs_nivelestudios_value,
      curp: res.data.rs_curp,
      rfc: res.data.rs_rfc,
      nip: res.data.rs_nipenviado,
      age: res.data.rs_edad,
      subjectCredit: res.data._rs_sujetocreditoid_value,
      procedureType: res.data._rs_tipotramiteid_value,
      curprenapo: res.data.rs_curprenapo,

      // Living
      street: res.data.rs_calle,
      extNumber: res.data.rs_numeroexterior,
      intNumber: res.data.rs_numerointerior,
      postalCode: res.data.rs_codigopostal,
      street2Id: res.data._rs_coloniaid_value,
      cityId: res.data._rs_municipioid_value,
      stateId: res.data._rs_estadoid_value,
      yearsAtCity: res.data.rs_antiguedadciudad,
      yearsAtHome: res.data.rs_antiguedadvivienda,
      propertyKindId: res.data._rs_tipoviviendaid_value,
      rentAmount: res.data.rs_montorenta,
      branchId: res.data._rs_sucursalid_value,
      contactSchedule: res.data.rs_horariodecontacto,
      maritalStatus: res.data.rs_estadocivil,
      economicDependents: res.data.rs_dependienteseconomicos,
      spouseLibertad: 0,
      spouseId: res.data._rs_conyuge_value,
      spouse: spouse as LeadProfilingSpouseResponse,
      // Job
      professionId: res.data._rs_profesionid_value,
      occupationId: res.data._rs_ocupacionid_value,
      companyName: res.data.rs_nombreempresa,
      ssn: res.data.rs_nss,
      yearsAtWork: res.data.rs_antiguedadempresa,
      fixedIncome: res.data.rs_ingresosfijos,
      variableIncome: res.data.rs_ingresosvariables,
      continueSameIncome: res.data.rs_continuarmismoingreso,
      patternName: res.data.rs_nombrepatron,
      salaryQuote: res.data.rs_salariobasecotizacion,
      employedStatus: res.data.rs_estadoempleado,
      admissionDate: res.data.rs_fechaingreso,
      lowDate: res.data.rs_fechabaja,
      incomePeriodicity: res.data.rs_periodicidadingresos,

      banxicoActivity: res.data._rs_actividadbanxicoid_value,
      economicActivityId: res.data._rs_actividadeconomicaid_value,
      economicSectorId: res.data._rs_sectoreconomicoid_value,
      positionId: res.data._rs_puestoid_value,

      // IMSS
      clientTypeImss: res.data.rs_tipoclienteimss,
      productTypeId: res.data._rs_tipoproductoimssid_value,
      agreementTypeId: res.data._rs_tipoconvenioid_value,
      requiredAmount: res.data.rs_montorequerido,
      totalAmount: res.data.rs_montototalapagar,
      interestAmount: res.data.rs_montototalinteres,
      ivaAmount: res.data.rs_montototaliva,
      monthlyDiscount: res.data.rs_descuentomensual,
      paymentCapacity: res.data.rs_capacidadpago,
      dueDate: res.data.rs_fechavencimiento,
      firstDiscountDate: res.data.rs_fechaprimerdescuento,
      abilityPay: res.data.rs_cuentacapacidadpago,
      fixedPayment: res.data.rs_pagofijo,
      monthlyTerm: res.data.rs_plazos,
      catWithoutIva: res.data.rs_catsiniva,
      bankId: res.data._rs_bancoid_value,
      keyAccount: res.data.rs_cuentaclave,
      // creditReference: res.data.rs_referenciacredito,
      biweeklyTerm: res.data.rs_plazoquincenal,
      maximumAmount: res.data.rs_montomaximo,
      monthlyRate: res.data.rs_tasa,
      paymentPeriodImss: res.data.rs_periodopago,
      clientType: res.data.rs_tipocliente,
      instrumentoMonetario: res.data.rs_instrumentomonetariomanejaracuentas,
      debtInsurance: res.data.rs_montoseguro
    };
  }

  public async findPLDMatch(id: string): Promise<OppoPLDMatchResponse> {
    const res = await this.get<OppoPLDMatchResponse, AxiosResponse<OpportunityHeadODataResponse>>(`d365api/v1/opportunities(${id})?$select=rs_coincidenciapld`, {
      headers: {
        "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
      }
    });
    return {
      pldMatch: res.data.rs_coincidenciapld
    };
  }

  public async updateVerificatorCodeOppo(id: string, nip: string): Promise<unknown> {
    return this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/opportunities(${id})`,
      {
        rs_codigoverificadorenviado: nip
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    )
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        return Promise.reject(error);
      });
  }

  public async getUserId(id: string): Promise<LeadUserResponse> {
    const res = await this.get<LeadUserODataResponse, AxiosResponse<ODataMultipleResponse<LeadUserODataResponse[]>>>(
      `d365api/v1/opportunities?$select=rs_folio,rs_telfonocelular&$expand=rs_sucursalid($select=_rs_gerentesucursalid_value)&$filter=(opportunityid eq ${id}) and (rs_sucursalid/rs_sucursalid ne null)`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    const user = res.data.value[0];
    const data: LeadUserResponse = {
      phone: user.rs_telfonocelular,
      number: user.rs_folio,
      managerId: user.rs_sucursalid?._rs_gerentesucursalid_value,
      branch: user.rs_sucursalid.rs_sucursalid
    };
    return data;
  }

  public async createAppoinment(appointment: Appointment, ownerId: string, telephone: string, id: string, branch: string): Promise<string> {
    const start = appointment.scheduledstart.replace("/", "-");
    const end = appointment.scheduledend.replace("/", "-");
    const res = await this.post<AppointmentODataResponse, unknown, AxiosResponse<AppointmentODataResponse>>(
      "d365api/v1/appointments",
      {
        subject: appointment.subject,
        description: appointment.description,
        scheduledstart: start + "T12:00:00.238Z", //appointment.scheduledstart,
        scheduledend: end + "T12:00:00.238Z", //appointment.scheduledend,
        rs_origenprospecto: 3,
        "ownerid@odata.bind": `/systemusers(${ownerId})`,
        rs_telefonocelular: telephone,
        "regardingobjectid_opportunity_appointment@odata.bind": `/opportunities(${id})`,
        rs_banderacallcenter: true,
        "rs_sucursalcitaid_Appointment@odata.bind": "/rs_sucursals(" + branch + ")"
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    return res.data.appointmentid;
  }

  public async getMotorResult(id: string): Promise<MotorResultResponse> {
    const response = await this.get<MotorResultResponse, AxiosResponse<DesitionalMotorODataResponse>>(
      `d365api/v1/opportunities(${id})?$select=opportunityid&$expand=rs_motordecisionalid($select=rs_ofertaminima)`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    const result: MotorResultResponse = {
      minimumOffer: response.data?.rs_motordecisionalid?.rs_ofertaminima,
      desicionalMotorId: response.data?.rs_motordecisionalid?.rs_motordecisionalid
    };

    return result;
  }

  public async getOpportunityRelationships(id: string): Promise<Partial<LeadOfferResponse>> {
    const referencias = await this.get<Partial<LeadOfferResponse>, AxiosResponse<ODataMultipleResponse<LeadOfferReferenciaODataResponse[]>>>(
      `d365api/v1/rs_referencias?$filter=_rs_solicitudid_value eq ('${id}') and statecode eq 0`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    const references: LeadOfferReferenceResponse[] = [];
    referencias.data.value.forEach((r) =>
      references.push({
        firstName: r.rs_nombre,
        middleName: r.rs_segundonombre,
        lastName: r.rs_apellidopaterno,
        mothersLastName: r.rs_apellidomaterno,
        relationshipTime: r.rs_tiemporelacion,
        referenceKind: r.rs_parentesco,
        mobile: r.rs_telefonocelular,
        phone: r.rs_telefonocasa
      })
    );

    const beneficiarios = await this.get<Partial<LeadOfferResponse>, AxiosResponse<ODataMultipleResponse<LeadOfferBeneficiarioODataResponse[]>>>(
      `d365api/v1/rs_beneficiarios?$filter=_rs_solicitudid_value eq ('${id}') and statecode eq 0`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    const beneficiaries: LeadOfferBeneficiaryResponse[] = [];
    for (let i = 0; i < beneficiarios.data.value.length; i++) {
      const beneficiario = beneficiarios.data.value[i];
      beneficiaries.push({
        firstName: beneficiario.rs_nombre,
        middleName: beneficiario.rs_segundonombre,
        lastName: beneficiario.rs_apellidopaterno,
        mothersLastName: beneficiario.rs_apellidomaterno,
        relationshipKind: beneficiario.rs_parentesco,
        birthDate: beneficiario.rs_fechanacimiento,
        birthPlaceId: beneficiario._rs_lugarnacimientoid_value,
        phone: beneficiario.rs_telefono,
        profitPercentage: beneficiario.rs_porcentajebeneficio,
        street: beneficiario.rs_calle,
        extNumber: beneficiario.rs_numeroexterior,
        intNumber: beneficiario.rs_numerointerior,
        postalCode: beneficiario.rs_codigopostal,
        street2Id: beneficiario._rs_coloniaid_value,
        cityId: beneficiario._rs_municipioid_value,
        rfc: beneficiario.rs_rfc,
        kind: beneficiario.rs_tipobeneficiario,
        id: beneficiario.rs_beneficiarioid
      });
    }

    return {
      references: references,
      beneficiaries: beneficiaries
    };
  }

  /**
   * Find the Offers from the specified Lead
   *
   * @param {string} id
   * @returns {Promise<{ quoteid: string }[]>}
   * @memberof LeadService
   */
  public async findExistOffers(id: string): Promise<{ quoteid: string }[]> {
    const res = await this.get<{ quoteid: string }, AxiosResponse<ODataMultipleResponse<{ quoteid: string }[]>>>(
      `d365api/v1/quotes?$select=quoteid&$filter=_opportunityid_value eq ('${id}') and statecode eq 0`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
    if (res.data != undefined && res.data?.value != null) return res.data?.value;
    else return null;
  }

  /**
   * Creates a Spouse and links it to the Lead
   *
   * @param {string} leadId
   * @param {Readonly<LeadSpouseRequest>} spouse
   * @returns {Promise<string>}
   * @memberof LeadService
   */
  public async createSpouse(id: string, spouse: Readonly<LeadSpouseRequest>): Promise<string> {
    const existant = await this.get<{ rs_conyugeid: string; _rs_solicitudid_value: string }, AxiosResponse<ODataMultipleResponse<{ rs_conyugeid: string; _rs_solicitudid_value: string }[]>>>(
      `d365api/v1/rs_conyuges?$select=rs_conyugeid,_rs_solicitudid_value&$filter=rs_curp eq '${spouse.curp}' and _rs_solicitudid_value eq ('${id}')`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    if (existant.data.value.length > 0) {
      return existant.data.value[0].rs_conyugeid;
    }

    const res = await this.post<ConyugeODataResponse, unknown, AxiosResponse<ConyugeODataResponse>>(
      "d365api/v1/rs_conyuges?$select=rs_conyugeid",
      {
        "rs_solicitudid@odata.bind": `/opportunities(${id})`,
        rs_nombre: spouse.firstName,
        rs_segundonombre: spouse.middleName,
        rs_apellidopaterno: spouse.lastName,
        rs_apellidomaterno: spouse.mothersLastName,
        rs_fechanacimiento: spouse.birthDate,
        rs_genero: spouse.genre,
        rs_nacionalidad: spouse.nationality,
        "rs_lugarnacimientoid@odata.bind": `/rs_entidadfederativas(${spouse.birthPlaceId})`,
        rs_curp: spouse.curp,
        rs_rfc: spouse.rfc,
        "rs_ocupacionid@odata.bind": `/rs_ocupacions(${spouse.occupationId})`,
        "rs_regimenmatrimonial@odata.bind": `/rs_regimenmatrimonials(${spouse.matrimonialRegimeId})`
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
    await this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/opportunities(${id})`,
      {
        "rs_conyuge@odata.bind": `/rs_conyuges(${res.data.rs_conyugeid})`
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
    return res.data.rs_conyugeid;
  }

  /**
   * Find the Lead by its Folio
   *
   * @param {string} folio
   * @returns {(Promise<string | undefined>)}
   * @memberof LeadService
   */
  public async findOppByFolio(folio: string): Promise<LeadSearchResponse | undefined> {
    // FIXME: Should not send request 'as is' since it can be modified by a MITM, it should also be a POST method
    const res = await this.get<LeadResponse, AxiosResponse<ODataMultipleResponse<OppHeadODataResponse[]>>>(
      `d365api/v1/opportunities?$select=opportunityid,rs_folio,_rs_finalidad_value,statecode,rs_tipoproyecto,rs_tipocliente&$filter=rs_folio eq '${folio}'&$orderby=createdon desc`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    if (res?.data?.value != null && res?.data?.value?.length > 0) {
      const lead = res.data.value[0];
      return {
        id: lead.opportunityid,
        // purposeId: lead._rs_finalidad_value,
        state: lead.statecode,
        projectType: lead.rs_tipoproyecto,
        clientType: lead.rs_tipocliente
      };
    } else {
      return undefined;
    }
  }

  public async getURLDocs(id: string): Promise<string> {
    const res = await this.get<{ rs_ligadocumentosperfilamiento?: string }, AxiosResponse<{ rs_ligadocumentosperfilamiento?: string }>>(
      `d365api/v1/opportunities(${id})?$select=rs_ligadocumentosperfilamiento`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
    return res.data?.rs_ligadocumentosperfilamiento;
  }

  public async getDocumentKindsLead(id: string): Promise<DocumentKindResponse[]> {
    const res = await this.get<TipoDocumentoODataResponse, AxiosResponse<ODataMultipleResponse<TipoDocumentoODataResponse[]>>>(
      `d365api/v1/rs_expedientes?$select=rs_name&$expand=rs_tipodocumentoid($select=rs_id)&$filter=(startswith(rs_name, 'Identificacion+Oficial') and statuscode ne 2) and (_rs_solicitudid_value eq ${id}) and (rs_tipodocumentoid/rs_tipodocumentoid ne null)`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
    const data: DocumentKindResponse[] = [];
    if (res.data?.value != null && res.data.value.length > 0) {
      res.data.value.forEach((elem) => {
        data.push({
          id: elem.rs_expedienteid,
          code: elem.rs_tipodocumentoid.rs_id,
          name: elem.rs_name
        });
      });
    }
    return data;
  }

  public async sendSmsCustom(id: string, nipField: string, nameVariable: string): Promise<void> {
    // FIXME: This shouldn't be done like this but as I mentioned several times, there's no backend for the frontend ¯\(°_o)/¯
    const res = await this.get<
      { rs_telfonocelular: string; rs_nipautorizacionsc: string; rs_nipautorizacion: string },
      AxiosResponse<{ rs_telfonocelular: string; rs_nipautorizacionsc: string; rs_nipautorizacion: string }>
    >(`d365api/v1/opportunities(${id})?$select=opportunityid,rs_telfonocelular,rs_nipenviado,rs_nipautorizacion,rs_nipautorizacionsc`, {
      headers: {
        "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
      }
    });

    let nip = "";
    let tag = "";
    if (nipField === "nipautorizacionsc") {
      nip = res.data.rs_nipautorizacionsc;
      tag = "sc";
    } else if (nipField === "nipautorizacion") {
      nip = res.data.rs_nipautorizacion;
      tag = "new";
    }

    const messageSms = await variablesService.findMessageSms(nameVariable);
    await this.post<unknown, unknown, AxiosResponse<unknown>>(
      "v1",
      {
        message: `${messageSms} ${nip}`,
        msisdns: [`52${res.data.rs_telfonocelular}`],
        tag: tag
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
  }

  public async findConfirmationSC(id: string, nip: string, nipField: string): Promise<boolean> {
    const res = await this.get<LeadResponse, AxiosResponse<ODataMultipleResponse<OpportunityHeadODataResponse[]>>>(
      `d365api/v1/opportunities?$select=opportunityid,rs_folio&$filter=rs_${nipField} eq '${nip}' and opportunityid eq ('${id}')`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
    return res.data.value.length == 1 && res.data.value[0].opportunityid !== undefined && res.data.value[0].rs_folio !== undefined;
  }

  public async findUnique(request: Readonly<LeadPrincipalImssRequest>): Promise<string> {
    // FIXME: Should not send request 'as is' since it can be modified by a MITM, it should also be a POST method
    const res = await this.get<OpportunityHeadODataResponse, AxiosResponse<ODataMultipleResponse<OpportunityHeadODataResponse[]>>>(
      `d365api/v1/opportunities?$select=opportunityid,rs_folio&$filter=(rs_curp eq '${request.curp}' and rs_rfc eq '${request.rfc}' and statecode eq 0)`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
    return res.data.value[0]?.rs_folio;
  }

  public async findUniquePhone(request: Readonly<LeadPrincipalImssRequest>): Promise<any> {
    const res = await this.get<OpportunityHeadODataResponse, AxiosResponse<ODataMultipleResponse<OpportunityHeadODataResponse[]>>>(
      `d365api/v1/opportunities?$select=opportunityid,rs_folio,rs_origen,_rs_sucursalid_value&$filter=(rs_curp eq '${request.curp}' or rs_rfc eq '${request.rfc}' or rs_telfonocelular eq '${request.mobile}' or rs_correoelectronico eq '${request.email}') and (statecode eq 0)`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
    if (res.data?.value != null && res.data.value.length > 0) return { folio: res.data.value[0]?.rs_folio, origen: res.data.value[0]?.rs_origen, sucursal: res.data.value[0]?._rs_sucursalid_value };
    else return null;
  }

  public async updatePhone(id: string, phone: string): Promise<unknown> {
    return this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/opportunities(${id})`,
      {
        rs_telfonocelular: phone
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    )
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        return Promise.reject(error);
      });
  }

  public async disqualifyOpp(id: string, status: number): Promise<unknown> {
    return this.post<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/LoseOpportunity`,
      {
        OpportunityClose: {
          actualend: Date.now,
          actualrevenue: 0,
          "opportunityid@odata.bind": "/opportunities(" + id + ")"
        },
        Status: status
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    )
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        throw error;
      });
  }

  public async saveConfirmation(id: string, nip: string): Promise<unknown> {
    return this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/opportunities(${id})`,
      {
        rs_nipenviado: nip
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    )
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        throw error;
      });
  }

  public async findOpportunityStatus(id: string): Promise<number> {
    const res = await this.get<{ statuscode?: number }, AxiosResponse<ODataMultipleResponse<{ statuscode?: number }>>>(
      `d365api/v1/opportunities?$select=statuscode&$filter=(_originatingleadid_value eq ${id})`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
    return res.data.value[0]?.statuscode;
  }

  public async createBeneficiaries(oppId: string, beneficiaries: Readonly<LeadBeneficiaryRequest[]>): Promise<string[]> {
    const ids: string[] = [];
    for (let i = 0; i < beneficiaries.length; i++) {
      const birthDate = new Date(beneficiaries[i].birthDate);
      const month = String(birthDate.getMonth() + 1).padStart(2, "0");
      const day = String(birthDate.getDate()).padStart(2, "0");
      const year = birthDate.getFullYear();
      const formattedDate = `${month}/${day}/${year}`;
      if (beneficiaries[i]?.id != undefined && beneficiaries[i]?.id != null && beneficiaries[i]?.id != "") {
        ids.push(beneficiaries[i].id);
        await this.patch<BeneficiarioODataResponse, unknown, AxiosResponse<BeneficiarioODataResponse>>(
          `d365api/v1/rs_beneficiarios(${beneficiaries[i].id})`,
          {
            "rs_solicitudid@odata.bind": `/opportunities(${oppId})`,
            rs_nombre: beneficiaries[i].firstName,
            rs_segundonombre: beneficiaries[i].middleName,
            rs_apellidopaterno: beneficiaries[i].lastName,
            rs_apellidomaterno: beneficiaries[i].mothersLastName,
            rs_fechanacimiento: new Date(formattedDate).toISOString(),
            "rs_lugarnacimientoid@odata.bind": `/rs_entidadfederativas(${beneficiaries[i].birthPlaceId})`,
            rs_parentesco: beneficiaries[i].relationshipKind,
            rs_rfc: beneficiaries[i].rfc,
            rs_telefono: beneficiaries[i].phone,
            rs_calle: beneficiaries[i].street,
            rs_numeroexterior: beneficiaries[i].extNumber,
            rs_numerointerior: beneficiaries[i].intNumber,
            rs_codigopostal: beneficiaries[i].postalCode,
            "rs_coloniaid@odata.bind": `/rs_colonias(${beneficiaries[i].street2Id})`,
            "rs_municipioid@odata.bind": `/rs_municipios(${beneficiaries[i].cityId})`,
            rs_porcentajebeneficio: beneficiaries[i].profitPercentage,
            rs_tipobeneficiario: beneficiaries[i].beneficiaryKind
          },
          {
            headers: {
              "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
            }
          }
        );
      } else {
        const res = await this.post<BeneficiarioODataResponse, unknown, AxiosResponse<BeneficiarioODataResponse>>(
          "d365api/v1/rs_beneficiarios?$select=rs_beneficiarioid",
          {
            "rs_solicitudid@odata.bind": `/opportunities(${oppId})`,
            rs_nombre: beneficiaries[i].firstName,
            rs_segundonombre: beneficiaries[i].middleName,
            rs_apellidopaterno: beneficiaries[i].lastName,
            rs_apellidomaterno: beneficiaries[i].mothersLastName,
            rs_fechanacimiento: new Date(formattedDate).toISOString(),
            "rs_lugarnacimientoid@odata.bind": `/rs_entidadfederativas(${beneficiaries[i].birthPlaceId})`,
            rs_parentesco: beneficiaries[i].relationshipKind,
            rs_rfc: beneficiaries[i].rfc,
            rs_telefono: beneficiaries[i].phone,
            rs_calle: beneficiaries[i].street,
            rs_numeroexterior: beneficiaries[i].extNumber,
            rs_numerointerior: beneficiaries[i].intNumber,
            rs_codigopostal: beneficiaries[i].postalCode,
            "rs_coloniaid@odata.bind": `/rs_colonias(${beneficiaries[i].street2Id})`,
            "rs_municipioid@odata.bind": `/rs_municipios(${beneficiaries[i].cityId})`,
            rs_porcentajebeneficio: beneficiaries[i].profitPercentage,
            rs_tipobeneficiario: beneficiaries[i].beneficiaryKind
          },
          {
            headers: {
              "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
            }
          }
        );
        ids.push(res.data.rs_beneficiarioid);
      }
    }
    return ids;
  }

  public deleteBeneficiaries(id: string): void {
    this.delete<unknown, unknown>(`d365api/v1/rs_beneficiarios(${id})`, {
      headers: {
        "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
      }
    })
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        throw error;
      });
  }

  public async getRecordsOppo(id: string): Promise<RecordResponse[]> {
    const res = await this.get<ExpedienteODataResponse, AxiosResponse<ODataMultipleResponse<ExpedienteODataResponse[]>>>(
      `d365api/v1/rs_expedientes?$select=rs_expedienteid,rs_name,rs_path,rs_fechavigenciacartalibranza,rs_fechaemisioncartalibranza,rs_foliocartalibranza,rs_estatuscartalibranza,rs_mediatype,_rs_tipodocumentoid_value&$expand=rs_tipodocumentoid($select=rs_id)&` +
        `$filter=(_rs_solicitudid_value eq ${id} and not startswith(rs_name, 'Identificacion+Oficial') and statecode eq 0)` +
        ` and (rs_tipodocumentoid/rs_tipodocumentoid ne null)`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
    const data: RecordResponse[] = [];
    if (res.data?.value != null && res.data.value.length > 0) {
      res.data.value.forEach((elem) => {
        data.push({
          id: elem.rs_expedienteid,
          code: elem.rs_tipodocumentoid.rs_id,
          name: elem.rs_name,
          path: elem.rs_path,
          dateRelease: elem.rs_fechaemisioncartalibranza,
          dateLimit: elem.rs_fechavigenciacartalibranza,
          enrrollment: elem.rs_foliocartalibranza,
          statusRelease: elem.rs_estatuscartalibranza,
          mediaType: elem.rs_mediatype,
          documentType: elem._rs_tipodocumentoid_value
        });
      });
    }
    return data;
  }

  public async disableRecord(id: string): Promise<unknown> {
    return this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/rs_expedientes(${id})`,
      {
        statuscode: 2,
        statecode: 1
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    )
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        throw error;
      });
  }

  public updatePersonalDataOppoImss(id: string, request: LeadGeneralRequest): Promise<unknown> {
    return this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/opportunities(${id})`,
      {
        rs_genero: request.genre,
        "rs_lugarnacimientoid@odata.bind": `/rs_entidadfederativas(${request.birthPlaceId})`,
        rs_nacionalidad: request.nationality ?? 1,
        rs_curp: request.curp,
        rs_rfc: request.rfc,
        "rs_paisnacimiento@odata.bind": `/rs_paises(${request.birthCountryId})`,
        rs_nss: request.ssn,
        //rs_mostrartabsipres2: true,
        rs_instrumentomonetariomanejaracuentas: request.monetaryInstrument
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    )
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        return Promise.reject(error);
      });
  }

  public async updateVerificatorCode(id: string, nip: string): Promise<unknown> {
    return this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/opportunities(${id})`,
      {
        rs_nipautorizacion: nip
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    )
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        return Promise.reject(error);
      });
  }

  public async getOfferPreautorizado(id: string): Promise<IsOfferPreautorizadoResponse> {
    const res = await this.get<IsOfferPreautorizadoResponse, AxiosResponse<ODataMultipleResponse<IsOfferPreautorizadoOData[]>>>(
      `d365api/v1/quotes?$select=quoteid&$expand=rs_productoid($select=rs_aplicapreautorizado)&$filter=_opportunityid_value eq '${id}'`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    let aplica = true;
    if (res.data.value != null) {
      if (res.data.value.length > 0) {
        if (res.data.value[0].rs_productoid != null) {
          aplica = res.data.value[0].rs_productoid?.rs_aplicapreautorizado ?? false;
        }
      }
    }
    return {
      producto: {
        aplicapreautorizado: aplica
      }
    };
  }

  public updateJobData(id: string, request: Readonly<LeadJobRequest>, bcAuth: boolean): Promise<unknown> {
    return this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/opportunities(${id})`,
      {
        "rs_profesionid@odata.bind": `/rs_profesions(${request.professionId})`,
        "rs_ocupacionid@odata.bind": `/rs_ocupacions(${request.occupationId})`,
        rs_nombreempresa: request.companyName,
        rs_antiguedadempresa: request.yearsAtWork,
        rs_nss: request.ssn,
        rs_ingresosfijos: Number(request.fixedIncome),
        rs_ingresosvariables: Number(request.variableIncome),
        rs_mostrartaboferta: true,
        rs_continuarmismoingreso: request.continueSameIncome,
        rs_nombrepatron: request.patternName,
        rs_salariobasecotizacion: request.salaryQuote,
        rs_estadoempleado: request.employedStatus,
        rs_fechaingreso: request.admissionDate,
        rs_fechabaja: request.lowDate,
        "rs_actividadeconomicaid@odata.bind": `/rs_actividadeconomicas(${request.economicActivityId})`,
        "rs_sectoreconomicoid@odata.bind": `/rs_sectoreconomicos(${request.economicSectorId})`,
        "rs_actividadbanxicoid@odata.bind": `/rs_actividadbanxicos(${request.banxicoActivity})`,
        "rs_puestoid@odata.bind": `/rs_puestos(${request.positionId})`,
        rs_periodicidadingresos: request.incomePeriodicity
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    )
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        return Promise.reject(error);
      });
  }

  public async info(id: string): Promise<ModalInfoPersonal> {
    const res = await this.get<LeadResponse, AxiosResponse<OppProfilingODataResponse>>(`d365api/v1/opportunities(${id})?$select=opportunityid,rs_folio,rs_correoelectronico,rs_telfonocelular`, {
      headers: {
        "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
      }
    });
    return {
      lead: res.data.opportunityid,
      email: res.data.rs_correoelectronico,
      phone: res.data.rs_telfonocelular
      // isPreautorizado: res.data?.rs_lead_quote_prospectoid[0]?.rs_productoid?.rs_aplicapreautorizado
    };
  }

  public async setSelectedOfferOnOpportunity(id: Readonly<string>, creditType: Readonly<number>): Promise<unknown> {
    let payload: {
      rs_ofertaelegida: number;
      statecode?: number;
      statuscode?: number;
      rs_tipofolio?: number;
    } = {
      rs_ofertaelegida: 1
    };

    // 1 = TRADITIONAL, 2 = EXPRESS
    if (creditType === 1) {
      payload = {
        rs_ofertaelegida: 1,
        rs_tipofolio: 717810000
      };
    }

    return this.patch<unknown, unknown, AxiosResponse<unknown>>(`d365api/v1/opportunities(${id})`, payload, {
      headers: {
        "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
      }
    })
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        throw error;
      });
  }

  public async sendUploadDocuments(id: string): Promise<unknown> {
    return this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/opportunities(${id})`,
      {
        rs_enviarsms: true
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    )
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        return Promise.reject(error);
      });
  }

  public async validateIdDocuments(id: string): Promise<boolean> {
    const res = await this.get<IdDocsODataResponse, AxiosResponse<ODataMultipleResponse<IdDocsODataResponse[]>>>(
      `d365api/v1/rs_expedientes?$select=rs_expedienteid,rs_name&$expand=rs_grupodocumentoid($select=rs_id),rs_tipodocumentoid($select=rs_id)&$filter=(_rs_solicitudid_value eq ${id} and not endswith(rs_name, '_PV') and statecode eq 0 and _rs_grupodocumentoid_value ne null and _rs_tipodocumentoid_value ne null) and (rs_grupodocumentoid/rs_id eq '03') and (rs_tipodocumentoid/rs_tipodocumentoid ne null)&$orderby=createdon desc`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    if (res.data?.value != null && res.data.value.length > 0) {
      const data: IdDocsODataResponse[] = res.data.value;
      const id = data[0].rs_tipodocumentoid?.rs_id;
      if (id == "0136") {
        return true;
      } else {
        const anverso = data.find((d) => d.rs_name.toLowerCase().includes("anverso"));
        if (!anverso) return false;
        const reverso = data.find((d) => d.rs_name.toLowerCase().includes("reverso"));
        if (!reverso) return false;
        return true;
      }
    } else {
      return false;
    }
  }

  public async getLogServicios(id: string, entity: string, type: number): Promise<LogServiciosResponse> {
    let entityLookup = "";
    if (entity == "prospecto") {
      entityLookup = "_rs_prospectoid_value";
    } else if (entity == "oportunidad") {
      entityLookup = "_rs_oportunidadid_value";
    }

    const res = await this.get<LogServiciosResponse, AxiosResponse<ODataMultipleResponse<LogServiciosODataResponse[]>>>(
      `d365api/v1/rs_logservicioses?$select=rs_response,rs_stateendpoint&$filter=(rs_tiposervicio eq ${type} and ${entityLookup} eq ${id})&$orderby=createdon desc`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    if (res.data?.value != null && res.data.value.length > 0) {
      const data: LogServiciosODataResponse = res.data.value[0];
      return {
        status: data.rs_stateendpoint,
        response: data.rs_response
      };
    }
    return null;
  }

  public updatePersonalDataOppoPreau(id: string, request: LeadGeneralRequest): Promise<unknown> {
    return this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/opportunities(${id})`,
      {
        rs_genero: request.genre,
        "rs_lugarnacimientoid@odata.bind": request.birthPlaceId ? `/rs_entidadfederativas(${request.birthPlaceId})` : null,
        rs_nacionalidad: request.nationality ?? 1,
        rs_curp: request.curp,
        rs_rfc: request.rfc,
        "rs_paisnacimiento@odata.bind": request.birthCountryId ? `/rs_paises(${request.birthCountryId})` : null,
        rs_nss: request.ssn,
        rs_telefonofijo: request.phone,
        "rs_NivelEstudios@odata.bind": request.educationLevelId ? `/rs_nivelestudioses(${request.educationLevelId})` : null
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    )
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        return Promise.reject(error);
      });
  }

  public async triggerCreditEndOppo(id: string): Promise<unknown> {
    return this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/opportunities(${id})`,
      {
        rs_detonasolicitud: 1
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    )
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        throw error;
      });
  }

  /**
   * Gets the statuscode of an opportunity by its ID
   *
   * @param {string} id
   * @returns {Promise<number>}
   * @memberof OpportunityService
   */
  public async getOpportunityStatuscode(id: string): Promise<number> {
    const res = await this.get<{ statuscode: number }, AxiosResponse<{ statuscode: number }>>(`d365api/v1/opportunities(${id})?$select=statuscode`, {
      headers: {
        "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
      }
    });
    return res.data.statuscode;
  }

  public updateLivingPlaceDataOppoPreau(id: string, request: Readonly<LeadLivingPlaceRequest>): Promise<unknown> {
    return this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/opportunities(${id})`,
      {
        rs_calle: request.street,
        rs_numeroexterior: request.extNumber,
        rs_numerointerior: request.intNumber,
        rs_codigopostal: request.postalCode,
        "rs_coloniaid@odata.bind": `/rs_colonias(${request.street2Id})`,
        "rs_municipioid@odata.bind": `/rs_municipios(${request.cityId})`,
        "rs_estadoid@odata.bind": `/rs_entidadfederativas(${request.stateId})`,
        rs_estadocivil: request.maritalStatus,
        rs_antiguedadciudad: request.yearsAtCity,
        rs_antiguedadvivienda: request.yearsAtHome,
        rs_horariodecontacto: request.contactSchedule,
        "rs_tipoviviendaid@odata.bind": `/rs_tipodeviviendas(${request.propertyKindId})`,
        rs_montorenta: request.rentAmount
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    )
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        return Promise.reject(error);
      });
  }

  public async getVerificacion(id: string, paso: string): Promise<PhoneVerification> {
    const res = await this.get<PhoneVerificationODataResponse, AxiosResponse<ODataMultipleResponse<PhoneVerificationODataResponse[]>>>(
      `d365api/v1/rs_verificaciontelefonomovils?$select=statuscode,rs_intentosvalidacionnumcel&$filter=(_rs_oportunidad_value eq ${id} and rs_pasodelenviosms eq ${paso})&$orderby=createdon desc`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    let result = null;
    if (res.data?.value != null && res.data.value.length > 0) {
      result = {
        intentos: res.data.value[0].rs_intentosvalidacionnumcel,
        statuscode: res.data.value[0].statuscode
      };
    } else {
      result = {
        intentos: 0,
        statuscode: 0
      };
    }

    return result;
  }

  public async detonatePlugin(id: string, request: any): Promise<unknown> {
    return this.patch<unknown, unknown, AxiosResponse<unknown>>(`d365api/v1/opportunities(${id})`, request, {
      headers: {
        "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
      }
    })
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        return Promise.reject(error);
      });
  }

  public async updateValidateCurp(id: string, option: number): Promise<unknown> {
    return this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/opportunities(${id})`,
      {
        rs_validacioncurp: option
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    )
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        return Promise.reject(error);
      });
  }

  public async updateOfferPre(id: string, offerId: string, campType: number): Promise<unknown> {
    return this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/opportunities(${id})`,
      {
        "rs_ofertapreautorizadaid@odata.bind": `/rs_ofertapreautorizadas(${offerId})`,
        rs_tipocampana: campType
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    )
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        throw error;
      });
  }

  public async findOpp(id: string): Promise<OpportunityResponse | undefined> {
    const res = await this.get<OpportunityResponse, AxiosResponse<OportunidadODataResponse>>(
      `d365api/v1/opportunities(${id})?$select=opportunityid,rs_folio,rs_nombres,rs_segundonombre,rs_apellidopaterno` +
        ",rs_apellidomaterno,statecode,rs_ocr,rs_cic,rs_anioregistro,rs_anioemision,rs_claveelector,rs_curp,rs_tipoproyecto" +
        ",rs_etapaspb,rs_tipocliente,rs_periodopago,rs_numerocredito,rs_correoelectronico,rs_telfonocelular" +
        ",_rs_finalidad_value,_rs_tipoconvenioid_value,rs_coincidenciapld,rs_destinorecursos,rs_fechanacimiento,rs_edad" +
        ",rs_validarmediocontacto,rs_origen,_rs_sucursalid_value,rs_matricula,_rs_estadodelegacionid_value,rs_nipautorizacion" +
        ",_rs_sujetocreditoid_value,_rs_tipotramiteid_value,rs_instrumentomonetariomanejaracuentas,rs_documentoscargados,rs_montoseguro" +
        ",_rs_paisnacimiento_value,rs_genero,_rs_lugarnacimientoid_value,rs_rfc,statuscode,rs_curprenapo,rs_detonasolicitud" +
        ",rs_validacioncurp,rs_nipenviado,_parentcontactid_value,rs_manifiestoempleo",
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    let names = res.data.rs_nombres;
    const ap = res.data.rs_apellidopaterno;
    const am = res.data.rs_apellidomaterno as string;
    let fullname = res.data.rs_nombres;
    if (res.data.rs_segundonombre) {
      fullname += ` ${res.data.rs_segundonombre}`;
      names += ` ${res.data.rs_segundonombre}`;
    }
    fullname += ` ${res.data.rs_apellidopaterno}`;
    if (res.data.rs_apellidomaterno) {
      fullname += ` ${res.data.rs_apellidomaterno}`;
    }

    return {
      id: res.data.opportunityid,
      number: res.data.rs_folio,
      fullname: fullname,
      firstName: res.data.rs_nombres,
      lastName: ap,
      middleName: am,
      secondName: res.data.rs_segundonombre,
      ocr: res.data.rs_ocr,
      year1: res.data.rs_anioregistro,
      year2: res.data.rs_anioemision,
      issueNumber: "00",
      electorKey: res.data.rs_claveelector,
      cic: res.data.rs_cic,
      curp: res.data.rs_curp,
      projectType: res.data.rs_tipoproyecto,
      stepPB: res.data.rs_etapaspb,
      clientType: res.data.rs_tipocliente,
      statecode: res.data.statecode,
      paymentPeriod: res.data.rs_periodopago,
      numCredito: res.data.rs_numerocredito,
      email: res.data.rs_correoelectronico,
      phone: res.data.rs_telfonocelular,
      purposeId: res.data._rs_finalidad_value,
      agreementTypeId: res.data._rs_tipoconvenioid_value,
      pldMatch: res.data.rs_coincidenciapld,
      purposeResources: res.data.rs_destinorecursos,
      birthDate: res.data.rs_fechanacimiento,
      age: res.data.rs_edad,
      contactMean: res.data.rs_validarmediocontacto,
      origen: res.data.rs_origen,
      branchId: res.data._rs_sucursalid_value,
      enrollment: res.data.rs_matricula,
      delegationState: res.data._rs_estadodelegacionid_value == null ? res.data._rs_lugarnacimientoid_value : res.data._rs_estadodelegacionid_value,
      nip: res.data.rs_nipautorizacion,
      subjectCredit: res.data._rs_sujetocreditoid_value,
      procedureType: res.data._rs_tipotramiteid_value,
      monetaryInstrument: res.data.rs_instrumentomonetariomanejaracuentas,
      chargeDocs: res.data.rs_documentoscargados,
      debtInsurance: res.data.rs_montoseguro,
      country: res.data._rs_paisnacimiento_value,
      gender: res.data.rs_genero,
      rfc: res.data.rs_rfc,
      statuscode: res.data.statuscode,
      curprenapo: res.data.rs_curprenapo,
      triggersRequest: res.data.rs_detonasolicitud,
      validateCurp: res.data.rs_validacioncurp,
      sentNip: res.data.rs_nipenviado,
      contactId: res.data._parentcontactid_value,
      employmentManifest: res.data.rs_manifiestoempleo
    };
  }

  public async updateOpportunity(id: string, request: any): Promise<unknown> {
    return this.patch<unknown, unknown, AxiosResponse<unknown>>(`d365api/v1/opportunities(${id})`, request, {
      headers: {
        "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
      }
    })
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        throw error;
      });
  }

  public async updateEmploymentConfirmation(id: string, confirmed: boolean): Promise<unknown> {
    const confirmedValue = confirmed ? 1 : 0;
    return this.patch<unknown, unknown, AxiosResponse>(
      `d365api/v1/opportunities(${id})`,
      {
        rs_confirmarempleopopup: confirmedValue
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
  }

  public async findSI(id: string): Promise<boolean> {
    const res = await this.get<ConsultaSC, AxiosResponse<ODataMultipleResponse<ConsultaSCODataResponse[]>>>(
      `d365api/v1/rs_consultaimsses?$select=rs_estatusempleo,createdon&$filter=(_rs_clienteid_value eq ${id} and statecode eq 0)&$orderby=createdon desc`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    let result: ConsultaSC;
    if (res.data?.value != null && res.data.value.length > 0) {
      result = {
        estatusEmpleo: res.data.value[0].rs_estatusempleo,
        fechaCreacion: res.data.value[0].createdon
      };
    } else {
      result = {
        estatusEmpleo: null,
        fechaCreacion: null
      };
    }

    if (result.fechaCreacion) {
      const fechaCreacion = new Date(result.fechaCreacion);
      const fechaActual = new Date();
      const diferenciaMs = fechaActual.getTime() - fechaCreacion.getTime();
      const dias = Math.floor(diferenciaMs / (1000 * 60 * 60 * 24));

      const diasVariable = await variablesService.getEnviromentVariable("rs_dias_consulta_imss");
      const diasVariableNumero = Number(diasVariable);
      if (dias < diasVariableNumero) {
        if (result.estatusEmpleo) {
          if (result.estatusEmpleo == "employed") return true;
        }
      }
    }

    return false;
  }

  public async getJsonUpdateData(id: string): Promise<JsonUpdateData> {
    const res = await this.get<JsonUpdateDataODataResponse, AxiosResponse<JsonUpdateDataODataResponse>>(`d365api/v1/opportunities(${id})?$select=rs_jsondatosactualizado`, {
      headers: {
        "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
      }
    });

    if (res?.data != null && res.data?.rs_jsondatosactualizado != null && res.data?.rs_jsondatosactualizado != "") {
      return JSON.parse(res.data.rs_jsondatosactualizado) as JsonUpdateData;
    } else {
      return null;
    }
  }

  public async findCW(id: string): Promise<boolean> {
    const res = await this.get<ConsultaSC, AxiosResponse<ODataMultipleResponse<ConsultaSCODataResponse[]>>>(
      `d365api/v1/rs_semanascotizadases?$select=rs_name,rs_semanascotizadasid&$filter=(_rs_solicitudid_value eq ${id} and statecode eq 0)`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    if (res.data?.value != null && res.data.value.length > 0) return true;
    else return false;
  }

  public async desicionalMotorUpdate(id: string, request: any): Promise<unknown> {
    return this.patch<unknown, unknown, AxiosResponse<unknown>>(`d365api/v1/rs_motordecisionals(${id})`, request, {
      headers: {
        "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
      }
    })
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        return Promise.reject(error);
      });
  }

  public async findTimeIMSS(id: string): Promise<LogServIMSSResponse> {
    const res = await this.get<LogServIMSSResponse, AxiosResponse<ODataMultipleResponse<LogServIMSSODataResponse[]>>>(
      `d365api/v1/rs_logservicioses?$select=rs_logserviciosid,rs_tiempoconsultaimss,rs_stateendpoint&` +
        `$filter=(rs_tiposerviciopalenca ne null and rs_stateendpoint eq 1 and _rs_oportunidadid_value eq ${id} and statecode eq 0)`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
    if (res.data?.value != null && res.data.value.length >= 3) {
      return {
        logId: res?.data?.value[0]?.rs_logserviciosid,
        tiempoConsulta: res?.data?.value[0]?.rs_tiempoconsultaimss
      };
    } else {
      return {
        logId: null,
        tiempoConsulta: null
      };
    }
  }

  public async findLogsPalenca(id: string): Promise<boolean> {
    const res = await this.get<ConsultaSC, AxiosResponse<ODataMultipleResponse<ConsultaSCODataResponse[]>>>(
      `d365api/v1/rs_logservicioses?$select=rs_logserviciosid,rs_tiempoconsultaimss,rs_stateendpoint,rs_tiposerviciopalenca&` +
        `$filter=(rs_tiposerviciopalenca ne null and rs_stateendpoint eq 1 and _rs_oportunidadid_value eq ${id} and statecode eq 0)`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    return this.cumpleTiposPalenca(res.data.value);
  }

  public cumpleTiposPalenca(registros: ConsultaSCODataResponse[]): boolean {
    if (registros.length < 3) {
      return false;
    }

    const tipos = new Set<number>();

    for (const r of registros) {
      if (r.rs_tiposerviciopalenca === null || r.rs_tiposerviciopalenca === undefined) {
        return false;
      }
      tipos.add(r.rs_tiposerviciopalenca);
    }

    return tipos.size >= 3 && tipos.has(0) && tipos.has(1) && tipos.has(2);
  }

  public async getFlagBoolNull(field: string, id: string): Promise<boolean> {
    const res = await this.get<{ field: boolean }, AxiosResponse<ODataMultipleResponse<{ field: boolean }[]>>>(`d365api/v1/opportunities?$select=${field}&$filter=(opportunityid eq ${id})`, {
      headers: {
        "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
      }
    });
    if (res.data?.value != null && res.data?.value.length > 0) {
      return res.data.value[0][field];
    } else {
      return null;
    }
  }

  public async getFieldStringNull(field: string, id: string): Promise<string> {
    const res = await this.get<{ field: string }, AxiosResponse<ODataMultipleResponse<{ field: string }[]>>>(`d365api/v1/opportunities?$select=${field}&$filter=(opportunityid eq ${id})`, {
      headers: {
        "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
      }
    });
    if (res.data?.value != null && res.data?.value.length > 0) {
      return res.data.value[0][field];
    } else {
      return null;
    }
  }

  public async getValidateMOP(id: string): Promise<number> {
    const res = await this.get<{ rs_validacionmop: number }, AxiosResponse<ODataMultipleResponse<{ rs_validacionmop: number }[]>>>(
      `d365api/v1/rs_motordecisionals?$select=rs_validacionmop&$filter=(_rs_solicitudid_value eq ${id})`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
    if (res.data?.value != null && res.data?.value.length > 0) {
      return res.data.value[0]["rs_validacionmop"];
    } else {
      return null;
    }
  }

  public async getLogsPLD(id: string): Promise<LogPLD> {
    const res = await this.get<Partial<LogPLD>, AxiosResponse<ODataMultipleResponse<LogPLD>>>(
      `d365api/v1/rs_logservicioses?$select=rs_confirmamensajepld,rs_response,rs_stateendpoint&` + `$filter=(statecode eq 0 and rs_tiposervicio eq 717810001 and _rs_oportunidadid_value eq ${id})`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    return res.data?.value[0];
  }

  public async getLogsPLDCount(id: string): Promise<number> {
    const res = await this.get<ODataMultipleResponse<number>, AxiosResponse<ODataMultipleResponse<number>>>(
      `d365api/v1/rs_logservicioses?$select=rs_confirmamensajepld,rs_response,rs_stateendpoint&` + `$filter=(statecode eq 0 and rs_tiposervicio eq 717810001 and _rs_oportunidadid_value eq ${id})`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    if (res.data?.value && Array.isArray(res.data.value)) return res.data.value.length;

    return 0;
  }

  public async createReferences(oppId: string, references: Readonly<LeadReferenceRequest[]>): Promise<string[]> {
    const ids: string[] = [];
    references.forEach(async (r) => {
      const existant = await this.get<{ rs_referenciaid: string }, AxiosResponse<ODataMultipleResponse<{ rs_referenciaid: string }[]>>>(
        `d365api/v1/rs_referencias?$select=rs_referenciaid,_rs_solicitudid_value&$filter=rs_nombre eq '${r.firstName}' and rs_apellidopaterno eq '${r.lastName}' and _rs_solicitudid_value eq ('${oppId}')`,
        {
          headers: {
            "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
          }
        }
      );

      if (existant.data.value.length > 0) {
        ids.push(existant.data.value[0].rs_referenciaid);
      } else {
        const res = await this.post<ReferenciaODataResponse, unknown, AxiosResponse<ReferenciaODataResponse>>(
          "d365api/v1/rs_referencias?$select=rs_referenciaid",
          {
            "rs_solicitudid@odata.bind": `/opportunities(${oppId})`,
            rs_nombre: r.firstName,
            rs_segundonombre: r.middleName,
            rs_apellidopaterno: r.lastName,
            rs_apellidomaterno: r.mothersLastName,
            rs_tiemporelacion: r.relationshipTime,
            rs_parentesco: r.referenceKind,
            rs_telefonocelular: r.mobile,
            rs_telefonocasa: r.phone
          },
          {
            headers: {
              "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
            }
          }
        );
        ids.push(res.data.rs_referenciaid);
      }
    });
    return ids;
  }
}

export const opportunityService = new OpportunityService();
